<template>
    <div>
        <nav class="navbar __navbar" role="navigation">
            <div class="container">
                <!-- Brand and toggle get grouped for better mobile display -->
                <div class="navbar-header">

                   <button type="button" class="navbar-toggle nav-button" data-toggle="collapse" data-target=".navbar-ex1-collapse">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="line1 icon-bar"></span>
                        <span class="line2"></span>
                        <span class="line3 icon-bar"></span>
                    </button>
                    <router-link to="/" class="navbar-brand"><img src="../assets/img/findworka-logo.png" class="__logoimg"></router-link>
                </div>
        
                <!-- Collect the nav links, forms, and other content for toggling -->
                <div class="collapse navbar-collapse navbar-ex1-collapse">
                    <ul class="nav navbar-nav __navbar-nav"> 
                        <!-- <li><router-link to="/build" class="__navcolor">Build Product <img src="../assets/img/right-arrow-top.svg" class=""> </router-link></li> -->
                        
                        <li><router-link to="./build" class="__navcolor">Build Product  </router-link></li>
                        <li><router-link to="./hire" class="__navcolor">Hiring </router-link></li>
                        <!-- <li><a href="https://hire.findworka.com" class="__navcolor" target="_blank">Hiring </a></li> -->
                        <li><router-link to="/academy" class="__navcolor">Training </router-link></li>
                        <li class="dropdown">
                            <a class="dropdown-toggle __navcolor" data-toggle="dropdown">Case Studies <img src="../assets/img/down-arrow.svg" class=""></a>
                            <ul class="dropdown-menu dropdown-menu-large row __dropdownlg">
                                <li class="col-sm-6">
                                    <ul>
                                        <router-link to="/Case-Studies-Software-Project"><li class="dropdown-header">Case studies of Software Projects</li>
                                        <li class="__b">A fellowship programme for aspiring developers to receive training from first-rate developers.</li>
                                        <li class="__a">Learn More &nbsp;<span><img src="../assets/img/right-arrow.svg"></span></li></router-link>
                                        <li class="__divider"></li>
                                    </ul>
                                </li>
                                <li class="col-sm-6">
                                    <ul>
                                        <router-link to="/Case-Studies-Talent-Placement"><li class="dropdown-header">Case studies of  Talent Placements</li>
                                        <li class="__b">An elite network of pre-vetted designers and developers with competence and real-world experience.</li>
                                        <li class="__a">Learn More &nbsp;<span><img src="../assets/img/right-arrow.svg"></span></li></router-link>
                                        <li class="__divider"></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li><router-link to="/about" class="__navcolor">About </router-link></li>
                        <li class="dropdown">
                            <!-- <router-link to="/" class="dropdown-toggle __navcolor" data-toggle="dropdown">Solutions <img src="../assets/img/down-arrow.svg" class=""></router-link> -->
                            <router-link to="/" class="dropdown-toggle __navcolor" data-toggle="dropdown">Solutions </router-link>
                            <ul class="dropdown-menu dropdown-menu-large row __dropdownlg">
                                <li class="col-sm-6">
                                    <ul>
                                        <router-link to="/hire">
                                            <li class="dropdown-header">Hire Talent</li>
                                            <li class="__b">Extend your team by hiring from our pool of topnotch tech talents and experience the best delivery on your projects.</li>
                                            <li class="__a">Learn More &nbsp;<span><img src="../assets/img/right-arrow.svg"></span></li>
                                        </router-link>
                                    </ul>
                                </li>
                                <li class="col-sm-6">
                                    <ul>
                                        <router-link to="/build"><li class="dropdown-header">Start a Project</li>
                                        <li class="__b">We have a team of dedicated product designers, software engineers and project managers that are ready to deliver happiness.</li>
                                        <li class="__a">Learn More &nbsp;<span><img src="../assets/img/right-arrow.svg"></span></li></router-link>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li><router-link to="/contact" class="__navcolor">Contact </router-link></li>
                        <li><router-link to="/refer" class="__navcolor">Refer </router-link></li>
                    </ul>
                    <ul class="nav navbar-nav navbar-right __navbar-nav1">
                        <li class="__navnumber"><a href="tel:(+234) 817 161 1434"><span><i class="fas fa-phone-alt"></i></span>&nbsp;+234 817 161 1434</a></li>
                        <!-- <li><router-link to="/pro" class="btn __joinbtn">Join PRO network</router-link></li> -->
                        <!-- <li><router-link to="/pro" class="btn __joinbtn">Become our pro</router-link></li> -->
                        <li><a href="https://calendly.com/wilfred-findworka/30min" class="btn __joinbtn" target="_blank">Schedule a Call </a></li>
                        
                        <!-- <li><router-link to="/pro" class="btn __joinbtn">Schedule a Call</router-link></li> -->
                    </ul>
                </div><!-- /.navbar-collapse -->
            </div>
        </nav>
    </div>
</template>

<script>
export default {

    mounted() {
        $(document).ready(function () {

            $('.nav-button').click(function () {
                $('.nav-button').toggleClass('change');
            })

        });
    }
}
</script>

<style scoped>
@import '../assets/css/navbar';

</style>




// WEBPACK FOOTER //
// src/components/navbar.vue